export default __webpack_public_path__ + "static/media/delivery.79baff2a.csv";